import type {
  BdResource,
  BdSharePermission,
} from '@bindoc-projects/resource-domain-lib';
import {
  ShareableType
} from '@bindoc-projects/resource-domain-lib';
import type { Cloneable } from '@bindoc-projects/util-domain-lib';

export type CaseExportDefaultTemplate = CaseExportTemplateCreate;

export class CaseExportTemplateCreate
  implements Cloneable<CaseExportTemplateCreate>
{
  constructor(
    public name: string,
    public properties: string[],
  ) {}

  clone(): CaseExportTemplateCreate {
    return new CaseExportTemplateCreate(
      this.name,
      JSON.parse(JSON.stringify(this.properties)),
    );
  }
}

export class CaseExportTemplate implements BdResource {
  public static fromObject(obj: any): CaseExportTemplate {
    let createdDate = null;
    let modifiedDate = null;

    if (obj.createdDate) {
      createdDate = new Date(obj.createdDate);
    }

    if (obj.modifiedDate) {
      modifiedDate = new Date(obj.modifiedDate);
    }
    return new CaseExportTemplate(
      obj.id,
      obj.name,
      createdDate,
      modifiedDate,
      obj.highestPermission,
      obj.properties,
    );
  }

  public resourceName = ShareableType.CASE_EXPORT_TEMPLATE;

  constructor(
    public id: string,
    public name: string,
    public createdDate: Date,
    public modifiedDate: Date,
    public highestPermission: BdSharePermission,
    public properties: string[],
  ) {}

  clone(...args): CaseExportTemplate {
    return new CaseExportTemplate(
      this.id,
      this.name,
      this.createdDate,
      this.modifiedDate,
      this.highestPermission,
      JSON.parse(JSON.stringify(this.properties)),
    );
  }
}
